import React, { useEffect, useState } from "react";
import { Warning } from "@phosphor-icons/react";
import api from "@/lib/api";

/**
 * Public banner shown when Super Admin enables Maintenance Mode.
 * Reads GET /killswitch/public (no auth required) and polls every 60s.
 * When mode='hard', the backend also returns 503 on non-admin writes.
 */
export default function KillswitchBanner() {
  const [state, setState] = useState({ mode: "off", message: "" });

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const { data } = await api.get("/killswitch/public");
        if (!cancelled) setState(data || { mode: "off", message: "" });
      } catch { /* silent */ }
    };
    load();
    const id = setInterval(load, 60000);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  if (state.mode === "off") return null;

  const isHard = state.mode === "hard";
  const bg = isHard ? "bg-red-600" : "bg-yellow-500";
  const label = isHard ? "MAINTENANCE · WRITES BLOCKED" : "MAINTENANCE";
  return (
    <div
      className={`${bg} text-white px-4 py-2.5 flex items-center gap-3 text-sm sticky top-0 z-30`}
      role="status"
      data-testid="killswitch-banner"
    >
      <Warning size={14} weight="fill" className="shrink-0" />
      <span className="label-tiny text-[10px] tracking-widest">{label}</span>
      <div className="flex-1 min-w-0">
        {state.message || "The platform is currently under maintenance. Please try again shortly."}
      </div>
    </div>
  );
}
